import React, { Component } from 'react';
import Questions from "./Questions";
import { HEAD_DEFAULT, MyIcon } from "../../common/baseConfig";
import { Button, Rate, Input, message, Modal, Radio, } from "antd";
import moment from "moment";
const { TextArea } = Input;
const RadioGroup = Radio.Group;
export default class ExerRecordPane extends Component {
  static propTypes = {

  };
  state = {
    analysisIndex: -1,
    noteIndex: -1,
    noteListIndex: -1,
    content: "",
    correctContent: "",//纠错内容
    visible: false,
    radio: 0,
    correctID: -1,
  }
  onCollect(ID) {
    this.props.actions.fetchAddCollecton({
      BusType: 0,
      BusID: ID
    }).then(res => {
      if (res.SuccessResponse) {
        this.props.onLoad();
      }
    })
  }
  submitNote(ID, StuID) {
    if (this.state.content.trim() === "") {
      message.warn("笔记内容不能为空");
      return;
    }
    this.props.actions.fetchAddQuestionNote({
      Question_ID: ID,
      Remart: this.state.content,
      StuID,
    }).then(res => {
      if (res.SuccessResponse) {
        this.setState({
          content: "",
        }, () => {
          this.props.onLoad();
        })
      }
    })
  }
  onChangeRdo(e) {
    this.setState({
      radio: e.target.value,
    });
  }
  submitCorrection() {
    const { radio, correctContent, correctID } = this.state;
    if (radio === 0) {
      message.warn("请选择错误类型");
      return;
    }
    if (correctContent.trim() === "") {
      message.warn("请填写详细内容")
      return;
    }
    this.props.actions.fetchAddQuestionerrorCorrection({
      ErrorType: radio,
      Question_ID: correctID,
      Remart: correctContent,
    }).then(res => {
      if (res.SuccessResponse) {
        message.success("您的纠错反馈已成功提交！");
        this.setState({
          visible: false,
          correctContent: "",
          radio: 0,
        })
      }
    })
  }
  render() {
    const { item, questionTypeName } = this.props;
    const { fetchAddQuestionerrorCorrectionPending } = this.props.center;
    const studentinfo = JSON.parse(localStorage.getItem("studentinfo"));
    const { analysisIndex, noteIndex, noteListIndex, content, visible, radio, correctContent } = this.state;
    let newMark = item.Mark;
    let newMyAnswer = item.MyAnswer, correctAnswer = item.Answer;
    if (item.QuestionType_ID === 5) {
      newMark = item.Answer;
    } else if (item.QuestionType_ID === 4) {
      newMyAnswer === "1" ? newMyAnswer = "正确" : newMyAnswer = "错误";
      correctAnswer === "1" ? correctAnswer = "正确" : correctAnswer = "错误";
    }
    return (
      <div className="center-exer-record-pane">
        <Questions data={item} body={item.Body} type={questionTypeName} />
        <div className="detail1">
          <div className="div1">
            {
              !newMyAnswer && <p className="p1">
                <MyIcon type="icontishi" style={{ color: "#ff9900" }} />
                <span style={{ color: "#ff9900" }}>未作答</span>
              </p>
            }
            {
              newMyAnswer && newMyAnswer !== correctAnswer && <p className="p1">
                <MyIcon type="iconshanchu" style={{ color: "#f01414" }} />
                <span style={{ color: "#f01414" }}>回答错误</span>
              </p>
            }
            {
              newMyAnswer && newMyAnswer === correctAnswer && <p className="p1">
                <MyIcon type="icongouxuan" style={{ color: "#42b961" }} />
                <span style={{ color: "#42b961" }}>回答正确</span>
              </p>
            }
            <p className="p2">
              <span>参考答案:</span>
              <span>{correctAnswer.length > 15 ? "具体看解析" : correctAnswer}</span>
            </p>
            <p className="p3">
              <span>您的答案:</span>
              <span>{newMyAnswer}</span>
            </p>
          </div>
          <div className="div2">
            <p className="p1" onClick={this.onCollect.bind(this, item.ID)}>
              <MyIcon type="iconshoucang" style={item.IsCollection === 0 ? null : { color: "#ffff00" }} />
              <span>{item.IsCollection === 0 ? "收藏本题" : "取消收藏"}</span>
            </p>
            <p className="p2" onClick={() => this.setState({
              visible: true,
              correctID: item.ID
            })}>
              <MyIcon type="iconbianjiqianbixieshuru2" />
              <span>纠错</span>
            </p>
            <p className="p3" onClick={() => {
              if (analysisIndex !== -1) {
                this.setState({
                  analysisIndex: -1,
                  noteIndex: -1,
                  noteListIndex: -1,
                })
              } else {
                this.setState({
                  analysisIndex: item.ID,
                  noteIndex: -1,
                  noteListIndex: -1,
                })
              }
            }}>
              <MyIcon type="iconxiala1" className={analysisIndex !== -1 ? "up" : ""} />
              <span>{analysisIndex !== -1 ? "收起解析" : "查看解析"}</span>
            </p>
          </div>
        </div>
        {
          analysisIndex === item.ID && <div className="detail2">
            <div className="level">
              <span className="tit">试题难度:</span>
              <Rate disabled defaultValue={item.Level} className="rate" />
            </div>
            <div className="mark">
              <span className="tit">参考解析:</span>
              <span>{newMark}</span>
            </div>
            <div className="doNote">
              <span className="tit">做题笔记:</span>
              <Button type="theme2" onClick={() => {
                if (noteIndex !== -1) {
                  this.setState({
                    noteIndex: -1,
                  })
                } else {
                  this.setState({
                    noteIndex: item.ID,
                  })
                }
              }}>{noteIndex !== -1 ? "收起" : "记笔记"}</Button>
            </div>
            {
              noteIndex === item.ID && <div className="inputNote">
                <TextArea value={content} placeholder="请输入笔记内容" className="txtArea" onChange={e => {
                  this.setState({
                    content: e.target.value
                  })
                }} />
                <Button type="theme" onClick={this.submitNote.bind(this, item.ID, studentinfo.StuID)}>提交</Button>
              </div>
            }
            <div className="notes">
              <h2 onClick={() => {
                if (noteListIndex !== -1) {
                  this.setState({
                    noteListIndex: -1,
                  })
                } else {
                  this.setState({
                    noteListIndex: item.ID,
                  })
                }
              }}>
                <span>{noteListIndex !== -1 ? "收起所有笔记" : "查看所有笔记"}</span><span>({item.NoteList.length})</span>
              </h2>
              {
                noteListIndex === item.ID && <div className="notesList">
                  {
                    item.NoteList.map(ele => (
                      <div className="note-item" key={ele.ID}>
                        <img src={studentinfo.HeadImg || HEAD_DEFAULT} alt="" />
                        <h3>
                          <p>
                            <span>{studentinfo.Name || "未知"}</span>
                            <span>{moment(new Date(ele.AddTime)).format("YYYY-MM-DD HH:mm:ss")}</span>
                          </p>
                          <p>{ele.Remart}</p>
                        </h3>
                      </div>
                    ))
                  }
                </div>
              }
            </div>
          </div>
        }
        <Modal
          wrapClassName="myNoteModal"
          centered
          maskClosable
          title={null}
          footer={null}
          width={740}
          onCancel={() => this.setState({
            visible: false,
            radio: 0,
            correctContent: "",
          })}
          visible={visible}
        >
          <h4>
            纠错
          </h4>
          <div className="modal-content">
            <p className="tit">
              一直在完善，从未停歇过，但有些题目可能仍然存在瑕疵，对您造成的不便我们深表歉意
            </p>
            <RadioGroup onChange={this.onChangeRdo.bind(this)} value={radio}>
              <Radio value={1}>含有错别字</Radio>
              <Radio value={2}>答案不正确</Radio>
              <Radio value={3}>题目不完整</Radio>
              <Radio value={4}>图片不存在</Radio>
              <Radio value={5}>解析不正确</Radio>
              <Radio value={6}>其他错误</Radio>
            </RadioGroup>
            <TextArea value={correctContent} placeholder="请输入详细内容" onChange={e => {
              this.setState({
                correctContent: e.target.value
              })
            }} />
            <div className="btns">
              <Button onClick={() => {
                this.setState({
                  visible: false,
                  radio: 0,
                  correctContent: "",
                })
              }}>取消</Button>
              <Button type="theme" onClick={this.submitCorrection.bind(this)} loading={fetchAddQuestionerrorCorrectionPending}>提交</Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/center/ExerRecordPane.js